import React, { Fragment } from "react";
import { Form, FloatingLabel } from "react-bootstrap";
import "./form-fields.scss";

const FormFields = (props) => {
  return (
    <>
      <Form.Group>
        {props.plainTextField ? (
          <Form.Control
            spellCheck="false"
            type={props.type}
            className={props.variant}
            id={props.id}
            name={props.name}
            placeholder={props.placeholder}
            disabled={props.disabled}
            value={props.value}
            onChange={props.changeHandler}
            onBlur={props.onBlur}
            onClick={props.onClick}
            onInput={props.inputHandler}
            onKeyDown={props.onKeyDown}
            maxLength={props.maxLength}
            minLength={props.minLength}
            pattern={props.pattern}
            ref={props.ref}
            defaultValue={props.defaultValue}
            style={props.style}
            aria-label={props.value}
            size={props.size}
          />
        ) : props.name === "get in touch" ||
          props.name === "feedbackController" ? (
          props.Label ? (
            <FloatingLabel controlId="floatingTextarea" label={props.Label}>
              <Form.Control
                as="textarea"
                spellCheck="false"
                className={props.variant}
                id={props.id}
                name={props.name}
                placeholder={props.placeholder}
                disabled={props.disabled}
                value={props.value}
                onChange={props.changeHandler}
                onBlur={props.onBlur}
                onClick={props.onClick}
                onInput={props.inputHandler}
                onKeyDown={props.onKeyDown}
                maxLength={props.maxLength}
                minLength={props.minLength}
                pattern={props.pattern}
                ref={props.ref}
                defaultValue={props.defaultValue}
                style={props.style}
              />
            </FloatingLabel>
          ) : (
            <Form.Control
              as="textarea"
              spellCheck="false"
              className={props.variant}
              id={props.id}
              name={props.name}
              placeholder={props.placeholder}
              disabled={props.disabled}
              value={props.value}
              onChange={props.changeHandler}
              onBlur={props.onBlur}
              onClick={props.onClick}
              onInput={props.inputHandler}
              onKeyDown={props.onKeyDown}
              maxLength={props.maxLength}
              minLength={props.minLength}
              pattern={props.pattern}
              ref={props.ref}
              defaultValue={props.defaultValue}
              style={props.style}
            />
          )
        ) : (
          <FloatingLabel controlId="floatingInput" label={props.Label}>
            <Form.Control
              spellCheck="false"
              type={props.type}
              className={props.variant}
              id={props.id}
              name={props.name}
              placeholder={props.placeholder}
              disabled={props.disabled}
              value={props.value}
              onChange={props.changeHandler}
              onBlur={props.onBlur}
              onClick={props.onClick}
              onInput={props.inputHandler}
              onKeyDown={props.onKeyDown}
              maxLength={props.maxLength}
              minLength={props.minLength}
              pattern={props.pattern}
              ref={props.ref}
              defaultValue={props.defaultValue}
              style={props.style}
              data-testid={props["data-testid"]}
            />
          </FloatingLabel>
        )}
      </Form.Group>
    </>
  );
};
export default FormFields;
